import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {HttpBackend, HttpClient, HttpResponse} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {ParamsBuildHelper} from "../helper/params-build-helper";
import {Obligor} from "../model/pro-report/HeaderDetails";
import {User} from "../model/User";

@Injectable({
  providedIn: 'root'
})
export class DirectAccessService {
  private httpClient: HttpClient;

  constructor(httpBackend: HttpBackend) {
    this.httpClient = new HttpClient(httpBackend);
  }

  getObligorsForDA(issueKeyNum: string, key: string): Observable<Obligor[]> {
    const url = environment.apiUrl + '/obligor-da' + ParamsBuildHelper.buildGetParams({
      'issueKeyNum': issueKeyNum.toString(),
      'key': key
    });
    return this.httpClient.get<Obligor[]>(url);
  }

  getDaUser(key: string): Observable<User> {
    return this.httpClient.get<User>(environment.apiUrl + '/user-da' + ParamsBuildHelper.buildGetParams({'key': key}))
  }

  downloadDirectAccessPdf(obligorId: number, key: string, dateTime: string): Observable<HttpResponse<Blob>> {
    return this.httpClient.get<Blob>(environment.apiUrl + '/pdf-report/daReport/' + obligorId + ParamsBuildHelper.buildGetParams(
      {
        'key': key,
        'dateTime': dateTime
      }
    ), {
      observe: 'response',
      responseType: 'blob' as 'json'
    });
  }
}
